export function handleStartAction (state) {
  return {
    ...state,
    loading: true,
    invalid: false
  }
}

export function handleFailureAction (state, action) {
  const { error } = action.payload
  console.error(error)
  return {
    ...state,
    loading: false,
    invalid: true,
    errorMessage: error.message
  }
}

export function handleStateChange (state, action) {
  let { errorMessage, loading } = action.payload
  if (errorMessage) {
    console.warn(errorMessage)
  } else {
    errorMessage = ''
  }
  return {
    ...state,
    loading,
    errorMessage
  }
}
